import Swiper from 'swiper';

const awardSwiper = new Swiper('.swiper-container-id-awards', {
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: 'auto',
  autoHeight: true,
});



// WEBPACK FOOTER //
// ./scripts/awards.js